import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Deterministic variant assignment per visitor (50/50) via localStorage.
// Respects a locked winner from GET /api/experiments/config/:key (admin can lock).
export function useExperiment(key, variants = ["A", "B"]) {
  const [variant, setVariant] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const storeKey = `adv_exp_${key}`;

    // Ensure session id
    let sid = localStorage.getItem("adv_exp_session");
    if (!sid) {
      sid = Math.random().toString(36).slice(2, 14) + Date.now().toString(36);
      localStorage.setItem("adv_exp_session", sid);
    }

    const assignAndTrack = (chosen) => {
      if (cancelled) return;
      localStorage.setItem(storeKey, chosen);
      setVariant(chosen);
      api.post("/experiments/event", { key, variant: chosen, event: "exposure", session: sid }).catch(() => {});
    };

    (async () => {
      // Check for a locked winner first
      try {
        const res = await api.get(`/experiments/config/${key}`);
        const locked = res.data?.locked_variant;
        if (locked && variants.includes(locked)) {
          assignAndTrack(locked);
          return;
        }
      } catch (e) {
        console.warn(`[experiment] config fetch failed for ${key}; using local variant`, e);
      }

      // Fallback: use existing local variant or assign random
      let v = localStorage.getItem(storeKey);
      if (!v || !variants.includes(v)) {
        v = variants[Math.floor(Math.random() * variants.length)];
      }
      assignAndTrack(v);
    })();

    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const track = (event) => {
    const sid = localStorage.getItem("adv_exp_session") || "";
    if (!variant) return;
    api.post("/experiments/event", { key, variant, event, session: sid }).catch(() => {});
  };

  return { variant, track };
}
